import React from 'react';
import PropTypes from 'prop-types';

const Uncertain = ({width = 26, height = 26}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 347 347"
    xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(10 -56)" fill="none" fillRule="evenodd">
      <circle
        stroke="#3F53CA"
        strokeWidth="20"
        fill="#FFF"
        cx="163.5"
        cy="229.5"
        r="163.5"
      />
      <text
        fontFamily="Arial-Black, Arial Black"
        fontSize="320"
        fontWeight="700"
        fill="#000">
        <tspan x="66.266" y="352">
          ?
        </tspan>
      </text>
    </g>
  </svg>
);

Uncertain.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default Uncertain;



// WEBPACK FOOTER //
// ./src/components/Icon/svg/uncertain.js